import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '/api/product/defect',
    name: 'productDefectGet',
    method: 'GET'
  });
  return [isRequestSuccessed, data || [], exec, isLoading];
});
